import { inject } from '@angular/core';
import { ActivatedRoute, CanActivateFn, Params, Router, UrlTree } from '@angular/router';
import { AppRoute, AppRouteParam, AppRouteQueryParam } from 'src/app/app.route';
import { AuthenticationService } from './authentication.service';

export const authenticationGuard: CanActivateFn = (): boolean | UrlTree => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);
  const activatedRoute = inject(ActivatedRoute);

  const businessUnit = activatedRoute.root.firstChild?.snapshot.paramMap.get(AppRouteParam.BusinessUnit);
  const hasAccessToken = authenticationService.hasAccessToken();

  // In this case we don't know the shareId or relationId so we cannot redirect to the login page with those parameters.
  if (!hasAccessToken) {
    // TODO: TBD URL
    return router.createUrlTree(['/', businessUnit]);
  }

  const expired = authenticationService.isAccessTokenExpired();

  if (expired) {
    const { shareId, sub } = authenticationService.getAccessToken()!;
    const queryParams: Params = {
      [AppRouteQueryParam.ShareId]: shareId,
      [AppRouteQueryParam.RelationId]: sub,
    };

    authenticationService.clearAccessToken();

    return router.createUrlTree(['/', businessUnit, AppRoute.Share, AppRoute.Login], {
      queryParams,
    });
  }

  return true;
};
